import {IPropsGetRouteGraphhopper} from "@containers/graphhopper/types";
import {getRouteGraphhopper} from "@containers/graphhopper/api/api";
import {keepPreviousData, useQuery} from "@tanstack/react-query";
import {buildQueryKeyGraphhopper} from "@containers/graphhopper/hooks/helpers/buildQueryKeyGraphhopper";

export const useGetRouteGraphhopperQuery = ({
                                                params,
                                            }: {
    params: IPropsGetRouteGraphhopper,
}) => {

    return useQuery({
        queryFn: () => getRouteGraphhopper(params),
        queryKey: buildQueryKeyGraphhopper(params.points),
        staleTime: Infinity,
        enabled:params.points?.length >=2,
        refetchOnWindowFocus: false,
        retry:false,
        placeholderData: keepPreviousData,
    });
}
